import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-simple-message',
  templateUrl: './modal-simple-message.component.html',
  styleUrls: ['./modal-simple-message.component.scss'],
})
export class ModalSimpleMessageComponent implements OnInit {

  @Input() isHtml: boolean;
  @Input() title: string;
  @Input() description;

  constructor(private modalController: ModalController) {}


  ngOnInit() {
  }

  dismiss() {
    this.modalController.dismiss();
  }
}